import { OAuthFlowElement } from '@swagger-api/apidom-ns-openapi-3-0';
class OAuthFlow extends OAuthFlowElement {}
export default OAuthFlow;